import { useCallback, useEffect } from "react";
import { useApi, createApiHook } from "../utils/apiUtils";

const useFetchAnswerOptions = () => {
  const { apiGet } = useApi();
  const useApiState = createApiHook([]);
  const { data, error, loading, startLoading, setResponse } = useApiState();

  const fetchAnswerOptions = useCallback(async () => {
    startLoading();
    const response = await apiGet("/answer_options", "Error al obtener opciones de respuesta");
    setResponse(response);
    return response?.data;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    fetchAnswerOptions();
  }, [fetchAnswerOptions]);

  return { data, error, loading, refetch: fetchAnswerOptions };
};

export default useFetchAnswerOptions;
